import React from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import { useIncomeSummaryModel } from "../incomeSummaryModel";
import { IIncomeEnum } from "../incomeSummaryService";
import { SummaryDataTable } from "./summaryDataTable";
import { IncomeDetailsDataTable } from "./incomeDetailsDataTable";
import { CostTable } from "./costTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const { tabsType, onExport } = useIncomeSummaryModel()
    const action =
        <YhAuth resCode={ResourceAuthEnum.STATIST_INCOME_EXPORT}>
            <>
                {tabsType === IIncomeEnum.INCOMEDETAILS && <Button
                    disabled={true}
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => onExport()}
                >导出</Button>}
            </>
        </YhAuth>

    const Table = (str: IIncomeEnum) => {
        switch (str) {
            case IIncomeEnum.ANNUALINCOME:
                return <DataTable />
            case IIncomeEnum.ANNUALCOST:
                return <CostTable />
            case IIncomeEnum.INCOMESUMMARY:
                return <SummaryDataTable />
            case IIncomeEnum.INCOMEDETAILS:
                return <IncomeDetailsDataTable />

        }

    }
    return (
        <YhBox title={action} style={{ height: 'calc(100vh - 260px)' }}>
            {Table(tabsType)}
        </YhBox>
    )
}